/**
 * Initialize the search filter.
 *
 * @param {Function} callback The callback function to execute after initialization.
 */
const init = async (callback) => {
	const input = document.querySelector('.js-gsfc-filter-search');

	// Check if search input exists
	if (!input) {
		return;
	}

	const searchSubmitBtn = document.querySelector(
		'.js-gsfc-filter-search-submit'
	);
	const clearSearchBtn = document.getElementById('js-clear-search');

	// Event handler for click on search submit button
	if (searchSubmitBtn) {
		searchSubmitBtn.addEventListener('click', async function (e) {
			e.preventDefault();
			await process(input);
			callback();
		});
	}

	// Event handler for keyup event in search input
	input.addEventListener('keyup', async function (e) {
		e.preventDefault();
		// Process search on pressing enter key
		if (e.keyCode === 13) {
			await process(input);
			callback();
		}
		showHideClear(input);
	});

	// Event handler for click on clear search button
	if (clearSearchBtn) {
		clearSearchBtn.addEventListener('click', async function (e) {
			e.preventDefault();
			// Clear search input value
			input.value = '';
			showHideClear(input);
			await process(input);
			callback();
		});
	}
};

/**
 * Show or hide the clear search button based on the input value.
 *
 * @param {HTMLElement} input The element representing the search input.
 */
const showHideClear = (input) => {
	const clearSearchBtn = document.getElementById('js-clear-search');
	if (input.value !== '') {
		clearSearchBtn.style.display = 'block';
	} else {
		clearSearchBtn.style.display = 'none';
	}
};

/**
 * Process the search filter.
 *
 * @param {HTMLElement} input The element representing the search input.
 * @return {Promise} A Promise that resolves after processing the filter.
 */
const process = (input) => {
	return new Promise((resolve) => {
		const value = input.value;

		// Update global filters with search value
		global.filters.search = value.replace(/[<>]/g, '');

		resolve();
	});
};

/**
 * Update the search filter based on global filters.
 */
const update = () => {
	// Update search input value and clear button visibility
	const input = document.querySelector('.js-gsfc-filter-search');
	if (global.filters.search !== undefined && global.filters.search !== '') {
		input.value = global.filters.search;
		showHideClear(input);
	}
};

// Export initialization and update functions
export default { init, update };
